import React from 'react';
import ClarityDiamonds from '../../../assets/images/Clarity-diamonds.png';
import ColorDiamonds from '../../../assets/images/Color-diamonds.png';

const DiamondInfo = () => (
    <div className="tw-px-6">
        <div>
            <div className="tw-py-4">
                <div className="tw-text-xl tw-mb-4 tw-font-bold">Special Reserve vs. Premium vs. Standard Diamonds</div>
                <p className="tw-text-gray-700 tw-text-sm tw-leading-6">
                    <span className="tw-font-bold tw-text-lg">Special Reserve VVS - </span>Very very slightly included stone with a DE-color rating, indicating a colorless appearance and ideal cut for maximum brilliance.
                </p>
                <p className="tw-text-gray-700 tw-text-sm tw-leading-6">
                    <span className="tw-font-bold tw-text-lg">Premium Vs - </span>Very Slightly Included stone with an FG-color rating, indicating high clarity and a near-colorless appearance.
                </p>
                <p className="tw-text-gray-700 tw-text-sm tw-leading-6 tw-mt-3">
                    <span className="tw-font-bold tw-text-lg">Industry standard SI - </span> Included stone with a GH-color rating, a common grade found in many retail jewelry stores.
                </p>
            </div>
            <div className="tw-pb-2">
                <div className="tw-text-lg tw-mb-4 tw-font-bold">Clarity</div>
                <img src={ClarityDiamonds} alt="clarity-diamonds" />
            </div>
            <div className="tw-pb-2">
                <div className="tw-text-lg tw-mb-4 tw-font-bold">Color</div>
                <img src={ColorDiamonds} alt="clarity-diamonds" />
            </div>
        </div>
    </div>
);

export default DiamondInfo;
